// react-bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ListGroup from 'react-bootstrap/ListGroup';
import Tooltip from 'react-bootstrap/Tooltip';

// project-imports
import useConfig from 'hooks/useConfig';

// types
import { ColorOption } from 'types/customizer';

// =============================|| CUSTOMIZER - HEADER THEME ||============================== //

export default function HeaderTheme({ headerColors }: { headerColors: ColorOption[] }) {
  const { onChangeThemePreset, headerColor } = useConfig();

  return (
    <ListGroup.Item>
      <h6 className="mb-1">Header Theme</h6>
      <p className="text-muted text-sm">Choose your Header theme color</p>
      <div className="theme-color preset-color">
        {headerColors.map(({ id, label }) => (
          <OverlayTrigger key={id} placement="top" overlay={<Tooltip>{label}</Tooltip>}>
            <a
              href="#!"
              className={headerColor === id ? 'active' : ''}
              data-value={id}
              aria-label={label}
              onClick={(e) => {
                e.preventDefault();
                onChangeThemePreset('headerColor', id);
              }}
            >
              <i className="ti ti-checks" />
            </a>
          </OverlayTrigger>
        ))}
      </div>
    </ListGroup.Item>
  );
}
